(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tca-personalizza-fields"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const TCA_ROOT_SELECTOR = '[data-tca-personaliza]';

  const TCA_PROPERTY_KEYS = Object.freeze([
    'properties[Texto]',
    'properties[Texto adicional]',
    'properties[Posición]',
    'properties[Archivo pendiente de envío]',
    'properties[Notas adicionales]',
    'properties[Confirmación personalización]'
  ]);

  const tcaInstances = new Map();

  function tcaGetContainersWithin(root) {
    const containers = [];

    if (!root) return containers;

    if (root instanceof Element && root.matches(TCA_ROOT_SELECTOR)) {
      containers.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(TCA_ROOT_SELECTOR).forEach(function (element) {
        containers.push(element);
      });
    }

    return containers;
  }

  function tcaPropertyIsEmpty(value) {
    return typeof value === 'string' && value.trim() === '';
  }

  function tcaCleanupInstance(uid) {
    const instance = tcaInstances.get(uid);

    if (!instance) return;

    instance.cleanups.forEach(function (cleanup) {
      try {
        cleanup();
      } catch (error) {
        console.warn('[TCA Personalización] Error durante cleanup:', error);
      }
    });

    if (instance.container instanceof HTMLElement) {
      instance.container.removeAttribute('data-tca-initialized');
    }

    tcaInstances.delete(uid);
  }

  function tcaAddListener(instance, target, type, handler, options) {
    target.addEventListener(type, handler, options);

    instance.cleanups.push(function () {
      target.removeEventListener(type, handler, options);
    });
  }

  function tcaGetRole(container, role) {
    return container.querySelector('[data-tca-role="' + role + '"]');
  }

  function tcaHasValidPersonalization(container) {
    const text = tcaGetRole(container, 'text');
    const file = tcaGetRole(container, 'file');

    const hasText =
      text instanceof HTMLInputElement &&
      text.value.trim().length > 0;

    const hasFile =
      file instanceof HTMLInputElement &&
      file.checked;

    return hasText || hasFile;
  }

  function tcaHasOrphanSecondText(container) {
    const text = tcaGetRole(container, 'text');
    const text2 = tcaGetRole(container, 'text2');

    if (!(text2 instanceof HTMLInputElement)) return false;

    const hasSecondText = text2.value.trim().length > 0;
    const hasMainText =
      text instanceof HTMLInputElement &&
      text.value.trim().length > 0;

    return hasSecondText && !hasMainText;
  }

  function tcaUpdateCounter(container, input) {
    if (!(input instanceof HTMLInputElement)) return;

    const maximum = input.getAttribute('maxlength');

    if (!maximum) return;

    const counter = container.querySelector(
      '[data-tca-counter-for="' + CSS.escape(input.id) + '"]'
    );

    if (!counter) return;

    counter.textContent = input.value.length + ' / ' + maximum;
  }

  function tcaCreateSummaryItem(label, value) {
    const item = document.createElement('div');
    item.className = 'tca-summary__item';

    const labelElement = document.createElement('span');
    labelElement.className = 'tca-summary__item-label';
    labelElement.textContent = label;

    const valueElement = document.createElement('span');
    valueElement.className = 'tca-summary__item-value';
    valueElement.textContent = value;

    item.append(labelElement, valueElement);

    return item;
  }

  function tcaUpdateSummary(container) {
    const summary = container.querySelector('[data-tca-summary]');
    const summaryItems = container.querySelector('[data-tca-summary-items]');
    const confirmationWrapper = container.querySelector(
      '[data-tca-confirm-wrapper]'
    );

    if (!summary || !summaryItems) return;

    const text = tcaGetRole(container, 'text');
    const text2 = tcaGetRole(container, 'text2');
    const position = tcaGetRole(container, 'position');
    const file = tcaGetRole(container, 'file');
    const notes = tcaGetRole(container, 'notes');
    const confirmation = tcaGetRole(container, 'confirmation');

    const items = [];

    if (
      text instanceof HTMLInputElement &&
      text.value.trim()
    ) {
      items.push({
        label: 'Texto',
        value: text.value.trim()
      });
    }

    if (
      text2 instanceof HTMLInputElement &&
      text2.value.trim()
    ) {
      items.push({
        label: 'Texto adicional',
        value: text2.value.trim()
      });
    }

    if (
      position instanceof HTMLSelectElement &&
      position.value
    ) {
      items.push({
        label: 'Posición',
        value: position.value
      });
    }

    if (
      file instanceof HTMLInputElement &&
      file.checked
    ) {
      items.push({
        label: 'Archivo',
        value: 'Pendiente de envío'
      });
    }

    if (
      notes instanceof HTMLTextAreaElement &&
      notes.value.trim()
    ) {
      items.push({
        label: 'Notas',
        value: notes.value.trim()
      });
    }

    summaryItems.replaceChildren();

    items.forEach(function (item) {
      summaryItems.appendChild(
        tcaCreateSummaryItem(item.label, item.value)
      );
    });

    summary.hidden = items.length === 0;

    const hasValidPersonalization =
      tcaHasValidPersonalization(container);

    if (confirmationWrapper) {
      confirmationWrapper.hidden = !hasValidPersonalization;
    }

    if (
      !hasValidPersonalization &&
      confirmation instanceof HTMLInputElement
    ) {
      confirmation.checked = false;
    }
  }

  function tcaHideError(container) {
    const errorBox = container.querySelector('[data-tca-error]');

    if (!errorBox) return;

    errorBox.hidden = true;

    const text = errorBox.querySelector('[data-tca-error-text]');

    if (text) {
      text.textContent = '';
    }
  }

  function tcaShowError(container, message) {
    const errorBox = container.querySelector('[data-tca-error]');

    if (!errorBox) return;

    const text = errorBox.querySelector('[data-tca-error-text]');

    if (text) {
      text.textContent = message;
    }

    errorBox.hidden = false;

    if (typeof errorBox.focus === 'function') {
      try {
        errorBox.focus({ preventScroll: true });
      } catch (error) {
        errorBox.focus();
      }
    }

    errorBox.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  function tcaValidate(container) {
    const effectiveRequired =
      container.dataset.tcaRequired === 'true';

    const confirmation = tcaGetRole(container, 'confirmation');

    if (tcaHasOrphanSecondText(container)) {
      return {
        valid: false,
        message:
          'Completa primero el texto principal o elimina el texto adicional.'
      };
    }

    const hasValidPersonalization =
      tcaHasValidPersonalization(container);

    if (
      effectiveRequired &&
      !hasValidPersonalization
    ) {
      return {
        valid: false,
        message:
          'Por favor, completa la personalización requerida antes de añadir el producto al carrito.'
      };
    }

    if (
      hasValidPersonalization &&
      (
        !(confirmation instanceof HTMLInputElement) ||
        !confirmation.checked
      )
    ) {
      return {
        valid: false,
        message:
          'Por favor, confirma que los datos de personalización son correctos.'
      };
    }

    return {
      valid: true,
      message: ''
    };
  }

  function tcaCleanFormData(formData, container) {
    TCA_PROPERTY_KEYS.forEach(function (key) {
      if (!formData.has(key)) return;

      const values = formData.getAll(key);

      const allEmpty =
        values.length === 0 ||
        values.every(tcaPropertyIsEmpty);

      if (allEmpty) {
        formData.delete(key);
      }
    });

    if (!tcaHasValidPersonalization(container)) {
      formData.delete(
        'properties[Confirmación personalización]'
      );
    }
  }

  function tcaSuppressEmptyFieldsForLegacyBrowser(container) {
    const suppressed = [];

    container.querySelectorAll('[data-tca-property]').forEach(
      function (field) {
        if (
          !(
            field instanceof HTMLInputElement ||
            field instanceof HTMLTextAreaElement ||
            field instanceof HTMLSelectElement
          )
        ) {
          return;
        }

        let shouldSuppress = false;

        if (
          field instanceof HTMLInputElement &&
          field.type === 'checkbox'
        ) {
          shouldSuppress = !field.checked;
        } else {
          shouldSuppress = field.value.trim() === '';
        }

        if (shouldSuppress && !field.disabled) {
          field.disabled = true;
          suppressed.push(field);
        }
      }
    );

    return function restore() {
      suppressed.forEach(function (field) {
        field.disabled = false;
      });
    };
  }

  function tcaInitContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    const uid = container.dataset.tcaUid;

    if (!uid) return;

    const existing = tcaInstances.get(uid);

    if (
      existing &&
      existing.container === container &&
      document.documentElement.contains(container)
    ) {
      return;
    }

    if (existing) {
      tcaCleanupInstance(uid);
    }

    const form =
      container.closest('form[data-type="add-to-cart-form"]') ||
      container.closest('form[action*="/cart/add"]');

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const instance = {
      uid: uid,
      container: container,
      form: form,
      cleanups: []
    };

    tcaInstances.set(uid, instance);
    container.setAttribute('data-tca-initialized', 'true');

    const handleContainerInput = function (event) {
      const target = event.target;

      if (
        !(
          target instanceof HTMLInputElement ||
          target instanceof HTMLTextAreaElement ||
          target instanceof HTMLSelectElement
        )
      ) {
        return;
      }

      tcaHideError(container);

      if (
        target instanceof HTMLInputElement &&
        target.hasAttribute('data-tca-maxlength')
      ) {
        tcaUpdateCounter(container, target);
      }

      tcaUpdateSummary(container);
    };

    const handleSubmit = function (event) {
      tcaHideError(container);

      const validation = tcaValidate(container);

      if (!validation.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();

        tcaShowError(container, validation.message);

        return;
      }

      /*
        Fallback solamente per browser privi di FormDataEvent.

        Horizon costruisce FormData sincronicamente durante il submit.
        I campi TCA vuoti vengono quindi disabilitati per la durata
        dell'attuale dispatch e riabilitati nella microtask successiva.
      */
      if (typeof FormDataEvent === 'undefined') {
        const restore =
          tcaSuppressEmptyFieldsForLegacyBrowser(container);

        if (typeof queueMicrotask === 'function') {
          queueMicrotask(restore);
        } else {
          Promise.resolve().then(restore);
        }
      }
    };

    const handleFormData = function (event) {
      if (
        typeof FormDataEvent !== 'undefined' &&
        event instanceof FormDataEvent
      ) {
        tcaCleanFormData(event.formData, container);
      }
    };

    tcaAddListener(
      instance,
      container,
      'input',
      handleContainerInput
    );

    tcaAddListener(
      instance,
      container,
      'change',
      handleContainerInput
    );

    tcaAddListener(
      instance,
      form,
      'submit',
      handleSubmit,
      true
    );

    if (typeof FormDataEvent !== 'undefined') {
      tcaAddListener(
        instance,
        form,
        'formdata',
        handleFormData
      );
    }

    container
      .querySelectorAll(
        'input[data-tca-maxlength]'
      )
      .forEach(function (input) {
        tcaUpdateCounter(container, input);
      });

    tcaUpdateSummary(container);
  }

  function tcaInitWithin(root) {
    tcaGetContainersWithin(root).forEach(function (container) {
      tcaInitContainer(container);
    });
  }

  function tcaCleanupWithin(root, sectionId) {
    const entries = Array.from(tcaInstances.entries());

    entries.forEach(function (entry) {
      const uid = entry[0];
      const instance = entry[1];

      const belongsToRoot =
        root instanceof Node &&
        (
          root === instance.container ||
          (
            typeof root.contains === 'function' &&
            root.contains(instance.container)
          )
        );

      const belongsToSection =
        typeof sectionId === 'string' &&
        (
          uid === sectionId ||
          uid.indexOf(sectionId + '-') === 0
        );

      if (belongsToRoot || belongsToSection) {
        tcaCleanupInstance(uid);
      }
    });
  }

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      const sectionId =
        event.detail &&
        typeof event.detail.sectionId === 'string'
          ? event.detail.sectionId
          : '';

      tcaCleanupWithin(event.target, sectionId);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      tcaInitWithin(event.target);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        tcaInitWithin(document);
      },
      { once: true }
    );
  } else {
    tcaInitWithin(document);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
